var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPfImg10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 144,
    viewBox: "0 0 201 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6667 20C53.1439 20 48.6667 24.4772 48.6667 30V114C48.6667 119.523 53.1439 124 58.6667 124H142.742C148.265 124 152.742 119.523 152.742 114V30C152.742 24.4772 148.265 20 142.742 20H58.6667ZM122.804 75.4731C126.086 72.4478 126.05 67.5851 122.737 64.5942C119.346 61.5336 114.28 57.466 107.363 53.1747C100.965 49.2049 95.5744 46.6717 91.5668 45.0837C87.1671 43.3402 82.6596 45.903 81.7781 50.5437C80.8815 55.2636 80.0179 61.9098 80.0179 70.0013C80.0179 78.2099 80.9067 84.9311 81.817 89.6627C82.6921 94.2112 87.0714 96.7681 91.409 95.1186C95.4325 93.5886 100.881 91.0904 107.363 87.0683C114.326 82.7485 119.413 78.5989 122.804 75.4731Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfImg10);
export default __webpack_public_path__ + "static/media/pf_img10.ad5f17b4a8081e136ddc15eb7f672164.svg";
export { ForwardRef as ReactComponent };